export default "__VITE_ASSET__90Kf$9Rt__"